export default __webpack_public_path__ + "static/session-do-8d302effa874acac6e7fdfbb57f47f49.png";